import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import { IMAGE_URL } from '../App';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faComment } from '@fortawesome/free-regular-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { motion } from 'framer-motion';

const Instagram = () => {
    const [instaData, setInstaData] = useState([]);
    const [loading, setLoading] = useState(false);
    const swiperRef = useRef(null);
    const navPrevRef = useRef(null);
    const navNextRef = useRef(null);

    const loadInsta = async () => {
        try {
            setLoading(true);
            const response = await axios.get('/instagram/feed');
            setInstaData(response.data.data);
            console.log(response.data.data);
        } catch (error) {
            console.error('Fehler beim Laden der Instagram-Daten:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadInsta();
    }, []);

    const renderPostCard = (post) => {
        if (!post) return null;

        return (
            <Link to={`${post.permalink}`} target="_blank" className="instagram-post-link">
                <div className="instagram-post-container">
                    <img
                        className="instagram-post-image"
                        src={post.media_url}
                        alt={`${post.username}`}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `https://placehold.co/300x300/e1e1e1/909090?text=Bild+fehlt`;
                        }}
                    />
                    <div className="instagram-post-overlay">
                        <div className="instagram-post-info">
                            <div className="instagram-post-likes">
                                <FontAwesomeIcon icon={faHeart} className="instagram-icon" />
                                <span className="instagram-count">{post.like_count}</span>
                            </div>
                            <div className="instagram-post-comments">
                                <FontAwesomeIcon icon={faComment} className="instagram-icon" />
                                <span className="instagram-count">{post.comments_count}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        );
    };

    return (
        <div className="instagram-section py-2 shadow">
            <div className="container-fluid">
                <p className="rakete-font rakete-rot text-center my-1 text-start fw-semibold pt-3 fs-2">
                    INSTAGRAM
                </p>
                <div className="instagram-swiper-container row justify-content-center py-4">
                    <Swiper
                        modules={[Navigation, Pagination, A11y]}
                        spaceBetween={10}
                        slidesPerView={1}
                        navigation={instaData.length > 1 ? {
                            prevEl: navPrevRef.current,
                            nextEl: navNextRef.current,
                        } : false}
                        pagination={{ clickable: true }}
                        loop={instaData.length > 3}
                        breakpoints={{
                            768: {
                                slidesPerView: 3,
                                slidesPerGroup: 3,
                                spaceBetween: 20,
                            },
                            992: {
                                slidesPerView: 4,
                                slidesPerGroup: 4,
                                spaceBetween: 30,
                            },
                        }}
                        className="instagram-swiper"
                        onSwiper={(swiper) => {
                            if (swiperRef.current === null) {
                                swiperRef.current = swiper;
                            }
                        }}
                    >
                        {instaData.map((post) => (
                            <SwiperSlide key={post.id} className="instagram-slide">
                                <div className="instagram-card">
                                    {renderPostCard(post)}
                                </div>
                            </SwiperSlide>
                        ))}
                        {instaData.length > 1 && (
                            <>
                                <div className="swiper-button-prev" ref={navPrevRef}></div>
                                <div className="swiper-button-next" ref={navNextRef}></div>
                            </>
                        )}
                        <div className="swiper-pagination"></div>
                    </Swiper>
                </div>
                <a
                    href="https://www.instagram.com/rakete_freiburg/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="instagram-follow-button text-center"
                >
                    <FontAwesomeIcon icon={faInstagram} className="instagram-follow-icon" />
                    <p className="instagram-follow-text text-center">Follow us!</p>
                </a>
            </div>
        </div>
    );
};

export default Instagram;